import React from 'react';
import { mapActions } from 'actions/MapActions';
import { criteriaActions } from 'actions/CriteriaActions';
import { criteriaStore } from 'stores/CriteriaStore';
import { defaultStrings, riskLevelRange } from 'js/config/config';
import standardsConfig from 'js/standards.config';
import { ResultsButton } from 'components/Criteria/ResultsButton';
import { LocationSelection } from 'components/Criteria/LocationSelection';
import { romanize } from 'utils/Utilities';

import _ from 'lodash';

//SUB COMPONENTS
class RiskLevelTitle extends React.Component {
  render() {
    return (
      <div className='criteria-container'>
        <h3 className='criteria-container__title'>
          <img src='app/images/circle_2.svg' alt='' />
          <span>Requested Data</span>
        </h3>
      </div>
    );
  }
}

class RiskLevelSelectionItems extends React.Component {
  render() {
    return <option value={this.props.value}>{this.props.rangeItem}</option>;
  }
}

class RiskLevelSelection extends React.Component {
  handleSelectChange(evt) {
    criteriaActions.riskLevelSelection(evt.target.value);
  }

  render() {
    const { standard, riskLevel, loads } = this.props;
    const disabled = standard === '41-17' || standard === '41-23';

    let containerClass = `risk-level-selector-container ${disabled ? 'disabled' : ''}`;
    let anyChecked = loads.some((load) => {
      return load.checked === 'checked';
    });
    if (anyChecked && riskLevel === 'default' && standard !== '41-17' && standard !== '41-23') {
      containerClass += '  warning-border';
    }
    let indents = [];
    for (let i = 1; i <= riskLevelRange; i++) {
      indents.push(<RiskLevelSelectionItems key={i} value={i} rangeItem={romanize(i)} />);
    }
    let riskLevelSelectedValue = $('#risk-level-selector :selected').text();
    return (
      <div className={'criteria-container__section risk-level-container col s6'}>
        <div className={'input-field'}>
          <div className={'criteria-title-item'}>
            <img className={'title-icon'} src='app/images/sm_icon_risk_level.svg' alt='' />
            <span>Risk Category</span>
            <img
              className={'info-icon'}
              src='app/images/icon_info.svg'
              alt=''
              title={defaultStrings.riskCategoryMoreInfo}
            />
            <div className={containerClass}>
              <p className='risk-level-selected-placeholder'>{riskLevelSelectedValue}</p>
              <select
                disabled={disabled}
                value={this.props.riskLevel}
                id='risk-level-selector'
                className='risk-level-selector browser-default'
                onChange={this.handleSelectChange}
              >
                <option value='default' disabled>
                  Select Risk Category
                </option>
                {indents}
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class SiteSoilClassSelection extends React.Component {
  handleSelectChange(evt) {
    criteriaActions.soilClassSelection(evt.target.value);
  }

  render() {
    let containerClass = 'risk-level-selector-container';
    let options = standardsConfig[this.props.standard].soilClasses;
    let optionElements = _.map(options, (o, i) => {
      return (
        <option key={o} value={i.toString()}>
          {o}
        </option>
      );
    });
    let siteSoilClassSelectedValue = standardsConfig[this.props.standard].soilClassText[this.props.soilClass];

    if (!siteSoilClassSelectedValue) {
      siteSoilClassSelectedValue = defaultStrings.soilInstruction;
    }

    if (this.props.seismic.checked === 'checked' && this.props.soilClass === -1) {
      containerClass = 'risk-level-selector-container warning-border';
    }

    const infoText =
      this.props.standard === '7-22' ? defaultStrings.siteSoilClassMoreInfo7_22 : defaultStrings.siteSoilClassMoreInfo;

    return (
      <div className={'criteria-container__section risk-level-container col s6'}>
        <div className={'input-field'}>
          <div className={'criteria-title-item'}>
            <img className={'title-icon'} src='app/images/sm_icon_soil_class.svg' alt='' />
            <span>Site Soil Class</span>
            <img className={'info-icon'} src='app/images/icon_info.svg' alt='' title={infoText} />
            <div className={containerClass}>
              <p className={'risk-level-selected-placeholder'}>{siteSoilClassSelectedValue}</p>
              <select
                value={this.props.soilClass !== -1 ? this.props.soilClass : 'disabled'}
                id='site-soil-class-selector'
                className='risk-level-selector browser-default'
                disabled={this.props.disableSoilClass}
                onChange={this.handleSelectChange}
                defaultValue={'Default'}
              >
                <option value='disabled' disabled>
                  {defaultStrings.soilInstruction}
                </option>
                {optionElements}
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class StandardsSelectionItems extends React.Component {
  render() {
    return <option value={this.props.value}>{this.props.item}</option>;
  }
}

class Standards extends React.Component {
  standardsVersionClick(event) {
    criteriaActions.standardsVersionSelection(event.target.value);
  }

  render() {
    let containerClass = 'risk-level-selector-container';
    let standardsSelectedValue = $('#standards-selector :selected').text();

    let indents = [];
    Object.keys(standardsConfig).forEach((key) => {
      indents.push(<StandardsSelectionItems key={key} value={key} item={standardsConfig[key].label} />);
    });

    return (
      <div className='standards-selector-container'>
        <div className={'criteria-container__section risk-level-container col s6'}>
          <div className={'input-field '}>
            <div className={'criteria-title-item'}>
              <img className={'title-icon'} src='app/images/sm_icon_standard_version.svg' alt='' />
              <span>{defaultStrings.standardsVersionLabel}</span>
              <img
                className={'info-icon'}
                src='app/images/icon_info.svg'
                alt=''
                title={defaultStrings.standardsVersionMoreInfo}
              />

              <div className={containerClass}>
                <p className='risk-level-selected-placeholder'>{standardsSelectedValue}</p>
                <select
                  value={this.props.standard}
                  id='standards-selector'
                  className='standards-selector browser-default'
                  onChange={this.standardsVersionClick}
                >
                  <option value='default' disabled>
                    Select Standard Version
                  </option>
                  {indents}
                </select>
              </div>
            </div>
          </div>
        </div>
        <p className='standards-selector-text-note s6'>NEW! ASCE/SEI 41 now available</p>
      </div>
    );
  }
}

class Measurements extends React.Component {
  measurementsClick(event) {
    criteriaActions.measurementsSelection(event.target.id);
  }

  render() {
    return (
      <div className={'criteria-container__section measurements-container'}>
        <div className={'criteria-title-item'}>
          <img className={'title-icon'} src='app/images/sm_icon_measurements.svg' alt='' />
          <span>{defaultStrings.measurementsLabel}</span>
        </div>
        <p className='inline-block fill--50p__wide'>
          <input
            checked={this.props.measurement === 'imperial'}
            onChange={this.measurementsClick}
            className={'with-gap'}
            name={'group2'}
            type={'radio'}
            id={'imperial'}
          />
          <label htmlFor={'imperial'}>{defaultStrings.imperial}</label>
        </p>
        <p className='inline-block fill--50p__wide'>
          <input
            checked={this.props.measurement === 'si'}
            onChange={this.measurementsClick}
            className={'with-gap'}
            name={'group2'}
            type={'radio'}
            id={'si'}
          />
          <label htmlFor={'si'}>{defaultStrings.si}</label>
        </p>
      </div>
    );
  }
}

class Loads extends React.Component {
  loadsClick(event, standardsVersion) {
    if (standardsVersion !== '41-17' && standardsVersion !== '41-23') {
      criteriaActions.loadsClick(event.target.id, event.target.checked);
    }
  }

  selectAllLoads() {
    criteriaActions.selectAllLoads();
  }

  handleLockedLoadClick() {
    mapActions.setLockedModalVisibility(true);
  }

  render() {
    let items = [];
    const { standardsVersion } = this.props;

    const is41StandardVersion = standardsVersion === '41-17' || standardsVersion === '41-23';

    for (let load of this.props.loads) {
      let disabled = false;

      if (load.label === 'Tsunami' && standardsVersion === '7-10') {
        disabled = true;
      }

      if (load.label === 'Tornado' && standardsVersion !== '7-22') {
        disabled = true;
      }

      if (is41StandardVersion) {
        if (load.label === 'Seismic' && !load.checked) {
          criteriaActions.loadsClick(load.label, true);
        } else if (load.label !== 'Seismic') {
          disabled = true;
        }
      }

      const opacityCheckbox =
        load.label === 'Seismic' && (standardsVersion === '41-17' || standardsVersion === '41-23');

      if (this.props.activeLicense || load.label === 'Tsunami' || load.label === 'Wind') {
        items.push(
          <p key={`${load.label}load`} className='fill--50p__wide'>
            <input
              type='checkbox'
              onChange={(e) => this.loadsClick(e, standardsVersion)}
              className={`filled-in ${opacityCheckbox ? 'opacity' : ''}`}
              id={`${load.label}`}
              checked={load.checked}
              disabled={disabled}
            />
            <label className={`${disabled || opacityCheckbox ? 'not-allowed-cursor' : ''}`} htmlFor={`${load.label}`}>
              {load.label}
            </label>
          </p>
        );
      } else {
        items.push(
          <p key={`${load.label}load`} className='fill--50p__wide' onClick={this.handleLockedLoadClick}>
            <input type='checkbox' className='filled-in' id={`${load.label}`} checked={load.checked} disabled={true} />
            <label htmlFor={`${load.label}`}>{load.label}</label>
          </p>
        );
      }
    }

    const hideShowAll = this.props.activeLicense ? 'select-all-include' : 'hidden';
    return (
      <div className={'criteria-container__section'}>
        <div className={'criteria-title-item'}>
          <img className={'title-icon'} src='app/images/sm_icon_include.svg' alt='' />
          <span>Load Types</span>
          <a className={hideShowAll} onClick={this.selectAllLoads}>
            Select all
          </a>
        </div>
        <div className='flex flex-row flex-wrap padding--small'>{items}</div>
      </div>
    );
  }
}

export class Criteria extends React.Component {
  constructor(props) {
    super(props);
    this.state = criteriaStore.getState();
    criteriaStore.listen(this.onChange.bind(this));
  }

  onChange(state) {
    this.setState(state);
  }

  componentDidMount() {
    $('.dropdown-button').dropdown({
      inDuration: 300,
      outDuration: 225,
      constrain_width: false,
      hover: false,
      gutter: 0,
      belowOrigin: true,
      alignment: 'left',
    });

    if (Object.keys(this.props.hash).length !== 0 && this.props.hash.constructor === Object) {
      // Set criteria store state to hash
      criteriaActions.riskLevelSelection(Number(this.props.hash.r));
      criteriaActions.standardsVersionSelection(this.props.hash.sv);
      criteriaActions.soilClassSelection(Number(this.props.hash.sc));
      criteriaActions.setLatLon(this.props.hash.lat, this.props.hash.lon);
      criteriaActions.measurementsSelection(this.props.hash.m);
      criteriaActions.setCheckedLoads(this.props.hash.l);
      criteriaActions.viewReport();
    }
  }

  render() {
    const activeLicense = this.props.userInfo.activeLicense === 'A';
    const { loads, latitude, soilClass, standardsVersion, riskLevel } = this.state;

    let criteriaWidgetVisable = latitude === 'Latitude' ? '' : 'visable';
    let anyChecked = loads.some((load) => {
      return load.checked === 'checked';
    });
    let seismicLoad = _.find(loads, (load) => {
      return load.label === 'Seismic';
    });
    let warning = {
      show: false,
      text: '',
    };

    if (anyChecked) {
      if (seismicLoad.checked === 'checked' && soilClass === -1) {
        warning.show = true;
        warning.text = defaultStrings.soilInstruction;
      }

      if (riskLevel === 'default' && standardsVersion !== '41-17' && standardsVersion !== '41-23') {
        warning.show = true;
        warning.text = defaultStrings.riskInstruction;
      }
    }

    return (
      <div>
        <LocationSelection key='location' {...this.state} />
        <div id={'criteria'} className={`criteria-container ${criteriaWidgetVisable}`}>
          <div>
            <RiskLevelTitle />
          </div>
          <div className='criteria-container__content white margin--small'>
            <div className='selection-container'>
              <Standards standard={this.state.standardsVersion} />
            </div>
            <div className='selection-container'>
              <RiskLevelSelection
                standard={this.state.standardsVersion}
                riskLevel={this.state.riskLevel}
                loads={this.state.loads}
              />
              <SiteSoilClassSelection
                soilClass={this.state.soilClass}
                standard={this.state.standardsVersion}
                seismic={seismicLoad}
              />
              <hr />
            </div>
            <Measurements measurement={this.state.measurement} />
            <Loads
              loads={this.state.loads}
              standardsVersion={this.state.standardsVersion}
              activeLicense={activeLicense}
            />
          </div>
          <ResultsButton key='readyforreport' readyForReport={this.state.readyForReport} warning={warning} />
        </div>
      </div>
    );
  }
}
